import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addSportMapping } from "@/api/sportsNew";
import { SportsNewQueryKeys } from "@/tanstackQuery/queries/sportsNew";
import { AddSportMappingParams } from "@/types/ApiResponses/Sport";

export const useAddSportMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: AddSportMappingParams) => addSportMapping(params),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SportsNewQueryKeys.SportMappings, variables.sportId],
      });
    },
  });
};
